(function () {
  'use strict';

  angular.module('app').component('hotelContentsPage', HotelContentsPageComponent());

  function HotelContentsPageComponent() {
    return {
      bindings: {},
      controller: HotelContentListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/hotel-contents/hotel-contents-page.component.html',
    };
  }

  HotelContentListCtrl.$inject = [
    '$location',
    'UtilService',
    'AbilityService',
    'SessionService',
    '$routeParams',
    'HotelService',
    'HotelContentService',
    'LanguageService',

    // Angular downgraded service
    'ng2Router',
  ];

  function HotelContentListCtrl(
    $location,
    UtilService,
    AbilityService,
    SessionService,
    $routeParams,
    HotelService,
    HotelContentService,
    LanguageService,

    // Angular downgraded service
    ng2Router
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    var companyWebsites = SessionService.getSelectedAccountCompany().websites;

    if (companyWebsites.length === 0) {
      vm.errorWebsites = true;
    }

    vm.permissions = {
      canCreate: AbilityService.can('create_hotel_accountadmin'),
    };

    vm.websiteId = $routeParams.WSID;
    vm.websiteName = vm.UtilService.findItemInArray(companyWebsites, 'id', vm.websiteId).name;
    vm.tabs = vm.UtilService.websiteTabs(vm.websiteId);

    // Methods
    vm.addHotelContent = addHotelContent;
    vm.onHotelContentShowed = onHotelContentShowed;

    vm.openHotelListModal = openHotelListModal;

    // Initializers
    getDefaultLanguage();
    // getHotelsContents();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getHotelsContents();
      });
    }

    function getHotelsContents() {
      vm.filterCriteria = HotelContentService.getFilterCriteria();
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      HotelContentService.getHotelsContents(vm.websiteId, vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function addHotelContent() {
      $location.path(`/hotel_contents/new`).search({ WSID: vm.websiteId });
    }

    function onHotelContentShowed(item, mode) {
      $location.path(`/hotel_contents/${item.id}`).search({ WSID: vm.websiteId, mode: mode });
    }

    function openHotelListModal() {
      // var hotelIds = [];

      // vm.items.forEach(function (content) {
      //   hotelIds.push(content.hotel_id);
      // });

      HotelService.openHotelListModal(vm.websiteId); // hotelIds
    }

    vm.goToWebsiteDetail = (websiteId) => {
      ng2Router.navigate(['/ng/websites', websiteId]);
    };

    vm.goToWebsiteNew = () => {
      ng2Router.navigate(['/ng/websites/new']);
    };
  }
})();
